import apiInternal from './servers/apiInternal';

const consultaWeb = {
  request: async ({ requestId }: { requestId: string }) => {
    const res = await apiInternal.get(`/request/${requestId}`);
    return res.data;
  },
  autoRequest: async ({ cnj, makeDownload = false, forced = false }: { cnj: string; makeDownload?: boolean; forced?: boolean }) => {
    const res = await apiInternal.post(`/autorequest`, { 
      value: cnj,
      makeDownload,
      forced,
    });
    return res.data;
  },
  getAutoRequestAdmin: async ({ idAutoRequest }: { idAutoRequest: string }) => {
    const res = await apiInternal.get(`/autorequest/admin/${idAutoRequest}`);
    return res.data;
  },
};
export default consultaWeb;
